export const FINISH_MEDIA = 'VIDEOPLAYER_FINISH_MEDIA'
export const SHOW_MEDIA = 'VIDEOPLAYER_SHOW_MEDIA'

export const showMedia = (mediaId) => {
  return { type: SHOW_MEDIA, data: mediaId }
}
export const finishMediaPlayback = () => {
  return { type: FINISH_MEDIA }
}
